<template>
    <v-parallax :src="heroImage" :height="heroHeight" class="hero-section">
        <!-- <v-container class="fill-height">
            <v-row  justify="center">
                <v-col cols="12" md="8" class="text-center">
                    <h1 class="display-2 font-weight-bold mb-4 white--text">
                        Tech Solutions
                    </h1>
                    <p class="headline white--text mb-6">
                        Innovación y tecnología a tu alcance
                    </p>
                    <v-btn color="primary" large @click="scrollToContact" class="cta-btn">
                        Solicita una demo
                    </v-btn>
                </v-col>
            </v-row>
        </v-container> -->
    </v-parallax>
</template>

<script>
export default {
    data() {
        return {
            heroImage: require('@/assets/hero/hero_desktop.jpg'), // Asegúrate de tener esta imagen
            mobileImage: require('@/assets/hero/hero_mobile.jpg'), // Imagen alternativa para móvil
            windowWidth: 0
        }
    },
    computed: {
        heroHeight() {
            return this.windowWidth < 960 ? '500px' : '700px'
        },
        currentHeroImage() {
            return this.windowWidth < 600 ? this.mobileImage : this.heroImage
        }
    },
    methods: {
        scrollToContact() {
            document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
        },
        updateWidth() {
            this.windowWidth = window.innerWidth
        }
    },
    mounted() {
        this.updateWidth()
        window.addEventListener('resize', this.updateWidth)
    },
    unmounted() {
        window.removeEventListener('resize', this.updateWidth)
    }
}
</script>

<style scoped>
.hero-section {
    transition: all 0.3s ease;
}

/* Ajustes para móvil */
@media (max-width: 960px) {
    h1.display-2 {
        font-size: 2.5rem !important;
    }

    p.headline {
        font-size: 1.25rem !important;
    }

    .cta-btn {
        font-size: 0.875rem !important;
        padding: 8px 24px !important;
    }
}

@media (max-width: 600px) {
    .hero-section {
        background-size: cover !important;
        background-position: center center !important;
    }

    h1.display-2 {
        font-size: 2rem !important;
        margin-bottom: 16px !important;
    }
}
</style>